// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import * as ApplicationBackend from "../backend/ApplicationBackend";
import * as Setting from "../Setting";
import i18next from "i18next";
import {withRouter} from "react-router-dom";
// import NewFileViewer from 'react-file-viewer';
import * as AuthBackend from "./AuthBackend";
import PDF from "../component/Pdfjs";
// import {Spin} from "antd";

class ViewtPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      applicationName: props.applicationName ?? props.match.params?.applicationName,
      msg: null,
      name: props.account ? props.account.name : "",
      username: props.account ? props.account.name : "",
      phone: "",
      email: "",
      dest: "",
      isVerifyTypeFixed: false,
      verifyType: "", // "email", "phone"
      current: 0,
      time: 4,
      url: "",
      loading: true,
    };
    this.form = React.createRef();
    this.timer = null;
  }

  componentDidMount() {
    const {type, language} = this.props.match.params;
    if (this.getApplicationObj() === undefined) {
      if (this.state.applicationName !== undefined) {
        this.getApplication();
      } else {
        Setting.showMessage("error", i18next.t("forget:Unknown forget type") + ": " + this.state.type);
      }
    }
    this.handleDown(type, language);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  getApplicationObj() {
    return this.props.application;
  }

  getApplication() {
    if (this.state.applicationName === undefined) {
      return;
    }

    ApplicationBackend.getApplication("admin", this.state.applicationName)
      .then((res) => {
        if (res.status === "error") {
          Setting.showMessage("error", res.msg);
          return;
        }
        this.onUpdateApplication(res.data);
      });
  }

  onUpdateApplication(application) {
    this.props.onUpdateApplication(application);
  }

  handleDown(type, language) {
    AuthBackend.downFile(type, language).then(
      res => {
        // const u = window.URL.createObjectURL(res);
        // window.open(u);
        if (res.byteLength > 0) {
          this.setState({
            url: res,
          });
        }
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    // const originPath = window.origin.replace("sso", "catalog");
    const originPath = window.location.host.includes("zetyun.cn") ? window.origin.replace("sso", "catalog") : window.origin.replace("sso", "www");
    const {type, language} = this.props.match.params;

    return <div className="pdf-box">
      {/* <Spin spinning={this.state.loading}> */}
      {/* {
        (this.state.url && !this.state.loading) && <PDF
          url={this.state.url}
          pageNum={1}
          width={760}
        />
      } */}
      {/* `${originPath}/backend/${i18next.t("login:agreement.html")}` */}
      {/* {
        (!this.state.url && !this.state.loading) && <iframe
          src={type === "policy" ? `${originPath}/backend/${language === "zh" ? "agreement.html" : "agreement-en.html"}` : `${originPath}/backend/${language === "zh" ? "privacy.html" : "privacy-en.html"}`}
          style={{width: "100%", height: "100%", border: "none"}}
        />
      } */}
      {/* </Spin> */}
      <iframe
          src={type === "policy" ? `${originPath}/backend/${language === "zh" ? "agreement.html" : "agreement-en.html"}` : `${originPath}/backend/${language === "zh" ? "privacy.html" : "privacy-en.html"}`}
          style={{width: "100%", height: "100%", border: "none"}}
        />
    </div>;
  }
}

export default withRouter(ViewtPage);
